import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { OnboardingSpotlight, OnboardingStepKeyEnum, useOnboardingFlattenedTour } from "../../../components/Onboarding";
import * as def from "./SideNavGuide.def";
import store from "../../../redux/store";
import { setOrganizationOnboardSettings } from "../../../redux/slices/organization";

export function SideNavGuide(props: def.SideNavGuideProps) {
    
    
    const navigate = useNavigate();
    const location = useLocation();
   
    // Onboarding Steps

    const { onboardSettings = {} } = useSelector((s: any) => s.organization);
    
    const pmTools: Record<string, boolean> = (onboardSettings?.pm_tools ||
        {}) as any;

    const completedSet = new Set<string>(
    Object.entries(pmTools)
        .filter(([, v]) => !!v)
        .map(([k]) => k),
    );

    
    const showSideNavOnboarding = useMemo(() => {

        if(location.pathname === onboardSettings?.current_location) return null;
        
        
        const settingsEligibleKeys = [OnboardingStepKeyEnum.PmTools, OnboardingStepKeyEnum.OrgSkills, OnboardingStepKeyEnum.Integrations];
      
        const currentKey = onboardSettings?.current_navigation;
        const eligibleKeys = [
          ...settingsEligibleKeys,
          OnboardingStepKeyEnum.RiskMitigation,
          OnboardingStepKeyEnum.ImportUsers,
          OnboardingStepKeyEnum.AllocateSkills,
          OnboardingStepKeyEnum.OrgHolidays,
          OnboardingStepKeyEnum.StrategyMap,
          OnboardingStepKeyEnum.Explore,
          OnboardingStepKeyEnum.InvitePeople
        ];
        const shouldShow =  eligibleKeys.includes(currentKey);
    

        if(!shouldShow) return null;

        if(settingsEligibleKeys.includes(currentKey)) return {
            
            ref:props.refs.settingLinkRef,
            navigate:"/settings",
            message:"This is where you can manage your Cadence Pro account",
            offsetToAdd: 2
        }
        if (OnboardingStepKeyEnum.Explore === currentKey)
          return {
            ref: props.refs.projectsLinkRef,
            navigate: "/workitems",
            message: "This is where you can explore work items",
            offsetToAdd: 2,
          };

        if(OnboardingStepKeyEnum.RiskMitigation === currentKey || OnboardingStepKeyEnum.StrategyMap === currentKey) return {
          ref: props.refs.strategyMapsLinkRef,
          navigate: "/strategymaps",
          message: "This is where you can manage your Strategy Maps",
          offsetToAdd: 1,
        };
        if (
          OnboardingStepKeyEnum.ImportUsers === currentKey ||
          OnboardingStepKeyEnum.InvitePeople === currentKey
        )
          return {
            ref: props.refs.resourcesLinkRef,
            navigate: "/people",
            message:
              "This is where you can manage your all Organization Resources",
            offsetToAdd: 1,
          };
        
        if (OnboardingStepKeyEnum.AllocateSkills === currentKey)
          return {
            ref: props.refs.resourcesLinkRef,
            navigate: "/people",
            message:
              "This is where you can manage your all Organization Resources",
            offsetToAdd: 1,
          };
        if (OnboardingStepKeyEnum.OrgHolidays === currentKey)
          return {
            ref: props.refs.settingLinkRef,
            navigate: "/settings",
            message: "This is where you can manage your Cadence Pro account",
            offsetToAdd: 1,
          };
        
        return null;
        
    }, [onboardSettings?.current_navigation, location.pathname]);




    const { totalSteps: globalTotal, getIndexForProvider } = useOnboardingFlattenedTour();
      

    
    

    return (
      showSideNavOnboarding && (
        <OnboardingSpotlight
          targetRef={showSideNavOnboarding.ref}
          message={showSideNavOnboarding.message}
          onDismiss={async () => {

           

            navigate(showSideNavOnboarding.navigate);
          }}

           onClose={()=>{
                      const next = onboardSettings || {};
          
                      store.dispatch(setOrganizationOnboardSettings({...next, current_navigation: null, current_location: null}))
                    }}
          type="one_time_next"
         
          preferredPlacements={["right"]}
        />
      )
    );
}